export const CALLS = {
  ROOT: '/calls',
  APARTMENTS: '/calls/apartments',
  APARTMENTS_ALLOCATED: '/calls/apartments/allocated',
  APARTMENTS_UNALLOCATED: '/calls/apartments/unallocated',
  ENG_NETWORKS: '/calls/engineering_networks',
  ENG_NETWORKS_ALLOCATED: '/calls/engineering_networks/allocated',
  ENG_NETWORKS_UNALLOCATED: '/calls/engineering_networks/unallocated',
  ENG_NETWORKS_MY_CALLS: '/calls/engineering_networks/mycalls',
  ENG_NETWORKS_MY_CALLS_ID: '/calls/engineering_networks/mycalls/:id',
};
